module.exports = {"231124001":"孙吴城区街道","231124100":"孙吴镇","231124101":"辰清镇","231124201":"西兴乡","231124202":"沿江满族乡","231124203":"腰屯乡","231124204":"卧牛河乡","231124205":"群山乡","231124206":"奋斗乡","231124207":"红旗乡","231124208":"正阳山乡","231124210":"清溪乡","231124402":"前进林场","231124403":"大河口林场","231124404":"正阳林场","231124405":"平山林场","231124406":"沿江林场","231124407":"辰清林场","231124408":"红旗林场","231124409":"向阳林场","231124410":"良种场","231124411":"种畜场","231124500":"红色边疆农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/231124.json
// module id = 729
// module chunks = 0